import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

// The design draws the image at 8px on every width, which is the `md.desktop` step.
const RADIUS = `var(${borderRadius.md.desktop})`;

/* `position: relative` anchors the title link's overlay, which makes the whole
   card one link. No breakpoints: the card fills whatever width it is given. */
export const card = css`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(${spacing.md});
  height: 100%;

  &:has(a:focus-visible) {
    outline: 2px solid var(${colors.stroke.focus});
    outline-offset: var(${spacing.xxs});
    border-radius: ${RADIUS};
  }
`;

/* The placeholder colour shows while the image loads and stands in for a post
   with no canonical image, so the grid keeps its rhythm either way. */
export const media = css`
  overflow: hidden;
  aspect-ratio: 16 / 9;
  border-radius: ${RADIUS};
  background-color: var(${colors.surface.disabled});
`;

export const image = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const body = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: var(${spacing.sm});
`;

export const title = css`
  margin: 0;
  font-family: var(${typography.heading.fontFamily});
  font-weight: var(${typography.heading.fontWeight});
  font-size: var(${typography.heading.sizes.xs.fontSize});
  line-height: var(${typography.heading.sizes.xs.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
  color: var(${colors.content.default});
`;

export const titleLink = css`
  color: inherit;
  text-decoration: none;

  &::after {
    position: absolute;
    inset: 0;
    content: '';
  }

  &:focus-visible {
    outline: none;
  }
`;

export const description = css`
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.secondary});
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

/* Pushed to the bottom so the buttons line up across a row of cards whose
   titles and descriptions differ in length. */
export const action = css`
  margin-top: auto;
`;
